import _ from 'lodash'
import { STORE_LISTING } from '../constants/actionTypes'

/**
 * NOTE: This is the eventual structure of the property we will get from PAL.
 */
const initialState = {
  /**
   * This holds everything related to the main property this whole page is for.
   */
}

export default function listingReducer(state = initialState, action) {
  switch (action.type) {
    case STORE_LISTING: {
      return _.merge({}, state, {
        ...action.listing,
      })
    }
    default:
      return state
  }
}

export { initialState }
